import { KROFieldDict, KRTZFieldDict } from "../fieldDict"

export type CommentsSidebarProps = {
    newCommentFieldDetails?: CreateNewCommentDetails,
    editMode?: boolean,
    executeScroll?: Function,
    filterByField?: string,
    setClearCommentsFilterHighlight?: Function,
    isLandslide?: boolean,
    is2007?: boolean,
    setNewCommentFieldDetails?: Function
}

export enum CommentsTabs {
    AllComments,
    MyComments
}

export type CreateNewCommentDetails = {
    visible?: boolean,
    fieldDictName?: KRTZFieldDict | KROFieldDict | string,
    fieldFormName?: string
}